import { actionTypesEnum } from '../enum';

export const getTiquetePorEmisor = (state = null, action) => {

    if (action.type === actionTypesEnum.getTiquetePorEmisor) {
        return action.payload;
    }

    return state;
};